import hashes from './arenaAssetHashes.json';
import sizes from './arenaAssetSizes.json';
const catalog: Readonly<Record<string, { hash: string; bytes: number }>> = sizes;

const versions: Readonly<Record<string, string>> = hashes;
const prefix = '/arena/';

// WHY: Every consumer uses the build's content digest so deploy timestamps cannot invalidate unchanged bytes.
export function arenaAssetUrl(path: string): string {
  const relative = path.startsWith(prefix) ? path.slice(prefix.length) : path;
  const name = relative.split('?')[0];
  const hash = versions[name];
  if (!hash) throw new Error(`Unknown Arena asset: ${path}`);
  return `${prefix}${name}?v=${hash}`;
}

// WHY: Build byte sizes remain valid when HTTP compression hides the decoded Content-Length.
export function arenaAssetSize(path: string): number | null {
  const pathname = new URL(path.startsWith('/') || /^https?:/.test(path) ? path : `${prefix}${path}`, 'https://shot.band').pathname;
  const relative = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : pathname;
  const entry = catalog[relative];
  if (!entry) return null;
  if (pathname.startsWith(prefix) && entry.hash !== versions[relative]) throw new Error(`Stale Arena asset size: ${pathname}`);
  return entry.bytes;
}
